var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.45801H2.5C2.15833 6.45801 1.875 6.17467 1.875 5.83301C1.875 5.49134 2.15833 5.20801 2.5 5.20801H17.5C17.8417 5.20801 18.125 5.49134 18.125 5.83301C18.125 6.17467 17.8417 6.45801 17.5 6.45801Z",
    fill: "#6E7682"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.625H5C4.65833 10.625 4.375 10.3417 4.375 10C4.375 9.65833 4.65833 9.375 5 9.375H15C15.3417 9.375 15.625 9.65833 15.625 10C15.625 10.3417 15.3417 10.625 15 10.625Z",
    fill: "#6E7682"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 14.792H8.33325C7.99159 14.792 7.70825 14.5087 7.70825 14.167C7.70825 13.8253 7.99159 13.542 8.33325 13.542H11.6666C12.0083 13.542 12.2916 13.8253 12.2916 14.167C12.2916 14.5087 12.0083 14.792 11.6666 14.792Z",
    fill: "#6E7682"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.7f76f7ea77d8d2f7e47e141eafb96d91.svg";
export { ForwardRef as ReactComponent };